var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vscode-icons:file-type-html"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.1323 102.004L13.7061 7.5H106.294L97.856 101.989L59.9436 112.5L22.1323 102.004Z",
    fill: "#E44F26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60 104.468L90.6375 95.9738L97.845 15.2288H60V104.468Z",
    fill: "#F1662A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M60 50.2762H44.6625L43.605 38.4075H60V26.8162H30.9375L31.215 29.9287L34.0613 61.8675H60V50.2762ZM60 80.3775L59.9475 80.3925L47.04 76.9087L46.215 67.665H34.5787L36.2025 85.86L59.9475 92.4525L60 92.4375V80.3775Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M59.959 50.2762V61.8675H74.2315L72.889 76.9012L59.959 80.3887V92.4487L83.7227 85.86L83.8952 83.9025L86.6177 53.3887L86.9027 50.2762H59.959ZM59.959 26.8162V38.4075H87.9565L88.189 35.805L88.7177 29.9287L88.9952 26.8162H59.959Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.5029455f132aa52dd1785fdc3eae0127.svg";
export { ForwardRef as ReactComponent };